import {isMobile} from 'react-device-detect';
import utils from '../utils';

const FlightDetails = (props) => {
 
    let {flights } = props;

    if(!flights || flights.length === 0)
        return(
            <section style={{ padding : 0}}>     
                <div className="card secondary" id="table_flights">
                    <h3>Flight details</h3>
                    <p>No flight details available.</p>
                </div>
            </section>
        )

    return (
        <section style={{ padding : 0}}>     
            <div className = "card secondary" id = "table_flights">
                <h3> Flight details</h3>
                    <table className = "" >
                    <thead>
                        {!isMobile &&
                        <tr>
                        <th>Origin</th>
                        <th>Dest</th>
                        <th>Carrier</th>
                        <th> Flight number </th>
                        <th>Flight date</th>
                        <th>Dep (LT)</th>
                        <th>Arr (LT)</th>
                        <th>Aircraft Type</th>
                        <th>Pieces</th>
                        <th>Weight</th>
                        </tr>
                        }

                        {isMobile &&
                        <tr>
                        <th> </th>
                        <th> </th>
                        </tr>

                        }
                    
                    </thead>

                    <tbody>
                        {
                            flights.map((flight, i) =>{    
        
                                i = i + 1;
                                let date = "";
                                let day_diff = "";

                                if(flight.flight_date)
                                    date = utils.convertDate(flight.flight_date, false);
                
                                if(flight.arrival_date < flight.departure_date)
                                    day_diff = "(+1)"
            
                                if(!isMobile){  
                                    return[
                                        <tr>
                                        <td>{flight.origin}</td>
                                        <td>{flight.dest}</td>
                                        <td>{flight.carrier}</td>
                                        <td>{flight.flight_number} </td>
                                        <td>{date}</td>
                                        <td>{!flight.departure_date ? "" :  utils.convertTime(flight.departure_date) }</td>
                                        <td>{!flight.arrival_date ? "" : utils.convertTime(flight.arrival_date)} {day_diff}</td>
                                        <td>{flight.aircraft_type} </td>
                                        <td>{flight.pieces} </td>
                                        <td>{!flight.weight || flight.weight === '0.0' ? "" : flight.weight + " kg"}</td>
                                        </tr>
                                    ]
                                }else{

                                    return [
                                        <tr> <td> <strong> Booked Segment #{i}</strong> </td> <td> </td>  </tr>,
                                        <tr> <td> Origin - Destination </td> <td>{flight.origin} - {flight.dest} </td>  </tr>,
                                        <tr> <td> Flight - Aircraft Type </td> <td>{flight.carrier}{flight.flight_number}/{date}  - {flight.aircraft_type} </td>  </tr>,
                                        <tr> <td> Dep (LT) -  Arr (LT) </td> <td> {!flight.departure_date ? "" :  flight.departure_date.slice(0,2) +":"+ flight.departure_date.slice(2,4) }  - {!flight.arrival_date ? "" : flight.arrival_date.slice(0,2) +":"+ flight.arrival_date.slice(2,4)} {day_diff} </td>  </tr>,
                                        <tr> <td> Pieces - Weight </td> <td>{flight.pieces} pcs - {!flight.weight || flight.weight === '0.0' ? "" : flight.weight + " kg"} </td>  </tr>,
                                    ]
                                }
                            })
                        }
                    </tbody>

                    </table>
            </div>
        </section>
    );
};
export default FlightDetails;